import { Label } from '@progress/kendo-react-labels'
import { StackLayout } from '@progress/kendo-react-layout'
import { DropDownList } from '@progress/kendo-react-dropdowns'

const himoku = ['型枠工', '鉄筋工', '鉄骨製作', '耐火被覆', '耐火巻付', 'PC躯体系', 'PCCW', 'ALC・ECP']

const jyungyaku = ['順', '逆']

const Structure = ['基礎', '地下１階', '地下２階', '地下３階', '地下４階～', '地上１～２階', '地上３～７階', '地上８～１５階', '地上１６～２５階', '地上２６～３５階', '地上３６～４５階', '地上４６階～']

export default function StructureSearchCondition() {
  return (
    <>
      <h3>検索条件</h3>

      <StackLayout gap={5} orientation="vertical">
        <Label>費目</Label>
        <DropDownList data={himoku} defaultValue={'型枠工'} />

        <Label>順・逆</Label>
        <DropDownList data={jyungyaku} defaultValue={'順'} />

        <Label>階数</Label>
        <DropDownList data={Structure} defaultValue={'基礎'} />
      </StackLayout>
    </>
  )
}
